import { Drawer, Loading } from "@/components";
import { useGetNotificationDetail } from "@/hooks";
import { useAuthStore } from "@/store/authStore";
import { useNotificationStore } from "@/store/notificationStore";
import { Notification, NotificationStatus } from "@/types";
import React, { useCallback, useEffect, useState } from "react";
import FormNotification from "./FormNotification";

type Props = {
  open: boolean;
  onClose: () => void;
};

const NewNotification: React.FC<Props> = ({ open, onClose }: Props) => {
  const { copyedNotification } = useNotificationStore();

  // Get role to display form fields and build schema
  const { user } = useAuthStore();

  // Initial data for copying notification
  const [initialData, setInitialData] = useState<Notification>();

  const getDefaultSendTime = useCallback(() => {
    const defaultTimeMs = new Date().getTime() + 60 * 60 * 1000 + 1 * 60 * 1000; // Add 1 hour and 1 minute
    return new Date(defaultTimeMs).toISOString();
  }, []);

  // Watch for changes in the copied notification
  const { notification, isLoading } = useGetNotificationDetail(
    copyedNotification?.notification?.id || null
  );

  useEffect(() => {
    if (notification && copyedNotification) {
      notification.status = NotificationStatus.DRAFT; // Set status to DRAFT when copying

      // If send_time in the past, set to default send time (now + 1h + 1m)
      const now = new Date();
      const caculatedTime =
        new Date(notification.send_time).getTime() > now.getTime()
          ? notification.send_time
          : getDefaultSendTime();
      notification.send_time = caculatedTime;

      // If isDeleteRecivers is true, clear all recivers
      if (copyedNotification.isDeleteRecivers) {
        notification.notificationsCompany = [];
        notification.notificationsGroup = [];
        notification.notificationsStore = [];
        notification.notificationsUser = [];
        notification.send_to_all_companies = false;
        notification.send_to_all_groups = false;
        notification.send_to_all_stores = false;
        notification.send_to_all_users = false;
      }

      setInitialData(notification);
    }
  }, [notification, copyedNotification]);

  if (isLoading) return <Loading />;

  const role = user?.role.name;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      label="通知作成"
      description="テーマ、内容及び添付ファイルをご確認ください。"
      disableBackdropClick
      >
      {/* Form fields for creating a notification go here */}
      {!!role && (
        <FormNotification
          onClose={onClose}
          initialData={initialData}
          role={role}
        />
      )}
    </Drawer>
  );
};

export default NewNotification;
